var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",class:['flex items-center justify-center box-border freemium-button',
           {'freemium-button_s': _vm.size === 's'},
           {'freemium-button_m': _vm.size === 'm'},
           {'freemium-button_l': _vm.size === 'l'},
           {'freemium-button_blurred': _vm.blurred},
  ]},[(_vm.icon)?_c('Icon',{staticClass:"mr-xs freemium-button__icon",attrs:{"name":_vm.icon.name,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }